export enum UserKind {
    SYSTEM = 0,
    HUMAN = 1,
    ROBOT = 2,
    ANY = 3,
    ROOT_SYSTEM = 4,
}
